export const getIsSpotifyUrl = (searchInputValue: string): boolean =>
  searchInputValue.includes('open.spotify.com')

export const getSpotifyTrackId = (searchInputValue: string): string => {
  const match = searchInputValue.match(/track\/([a-zA-Z0-9]{22})/)
  return match ? match[1] : ''
}
